import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Checkbox } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import ContactCard from './components/ContactCard';
import { Contact } from 'models/Contact';
import ContactsContext from '../../../../providers/Contacts/Contacts.context';
import TableEmptyState from 'components/ReorderResizeTable/components/TableEmptyState';
import { getHasElementsInArray, getIsArrayEmpty } from 'utils';

import './ContactsCards.styles.scss';

type ContactsCardsProps = {
  className?: string;
  isLoading?: boolean;
  contacts: Contact[];
  handleEdit: (contact: Contact) => void;
  handleDelete: (id: string) => void;
};

const ContactsCards: React.FC<ContactsCardsProps> = (props) => {
  const { className, contacts, handleEdit, handleDelete } = props;

  const classes = classNames('contacts-cards', className);

  const { t } = useTranslation();

  const { selected, isAllSelected, selectAll, removeAll, updateSelected } =
    useContext(ContactsContext);

  const hasSelectedItems = useMemo(
    () => getHasElementsInArray(selected),
    [selected],
  );

  if (getIsArrayEmpty(contacts))
    return <TableEmptyState className="contacts-cards__empty-state" />;

  return (
    <div className={classes}>
      <div className="contacts-cards__select-all">
        <Checkbox
          label={t('selectAll')}
          checked={isAllSelected}
          onChange={isAllSelected ? removeAll : selectAll}
        />
      </div>

      {contacts.map((contact) => (
        <ContactCard
          key={contact._id}
          contact={contact}
          isSelected={selected.some(({ _id }) => _id === contact._id)}
          handleEdit={() => handleEdit(contact)}
          handleDelete={() => handleDelete(contact._id)}
          handleOnSelect={() => updateSelected(contact)}
          handleOnClick={() => {
            if (hasSelectedItems) {
              updateSelected(contact);
            } else handleEdit(contact);
          }}
        />
      ))}
    </div>
  );
};

export default ContactsCards;
